













































































































































































































import { Component, Vue, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
const Creditors = namespace("CreditorsModule");
import { VueTelInput } from "vue-tel-input";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import {
  required,
  max,
  numeric,
  email,
  min,
} from "vee-validate/dist/rules";
import BankInfo from "@/components/BankInfo.vue";
import Country from "@/components/Country.vue";
import InvoiceType from "@/components/InvoiceType.vue";
import * as _ from 'lodash';
import NotificationMixin from "@/mixins/notification.mixin";

// Add the rules
extend("required", {
  ...required,
  message: "This field is required",
});
extend("email", {
  ...email,
  message: "The field must be a email address.",
});
extend("max", {
  ...max,
  params: ["length"],
  message: "Max length {length}",
});
extend("min", {
  ...max,
  params: ["length"],
  message: "Min length {length}",
});
extend("numeric", {
  ...numeric,
  message: "Field type must be numeric",
});

@Component({
  name: "CreditorAdd",
  mixins: [NotificationMixin],
  components: {
    VueTelInput,
    ValidationProvider,
    ValidationObserver,
    BankInfo,
    Country,
    InvoiceType,
  },
})
export default class CreditorAdd extends Mixins(NotificationMixin) {
  @Creditors.State
  public creditorData!: Array<any>;

  @Creditors.Action
  public retrieveCreditorById!: (params: number) => Promise<any>;

  @Creditors.Action
  public addCreditor!: (data: any) => Promise<any>;

  @Creditors.Action
  public editCreditor!: (data: any) => Promise<any>;

  private ClickAddMore = false;
  private showButtonAddMore = true;
  private invoiceTypeOptions: Array<any> = [];
  private isLoading = false;

  private CreditorCategoryOptions = [
      {text: "HANDEL", value: "HANDEL"},
      {text: "PASSAG", value: "PASSAG"}
  ];

  private BankAddMore = [
    {
      BankAccType: "",
      BankAccNr: "",
      BankCurrCode: "",
      BankTypePrimary: 203201,
      BankName: "",
      BankSwiftAddress: "",
    },
  ];

  private creditorField = {
    AdmNr: 0,
    Creditor: 0,
    Name: "",
    SearchCode: "",
    Country: "",
    PostalCode: "",
    Address1: "",
    City: "",
    Telephone: "",
    ContactEmail: "",
    Category: "HANDEL",
    BankInfo: [
      {
        BankAccType: "",
        BankAccNr: "",
        BankCurrCode: "",
        BankTypePrimary: 0,
        BankName: "",
        BankSwiftAddress: "",
      },
    ],
    CustomField: {
      MainContactName: "",
      MainContactEmail: "",
      RegisterName: "",
      InvoiceType: [],
    },
  };

  created() {
    this.getCreditorData();
  }

  isAddCreditor() {
    return this.$route.params.creditorId == undefined;
  }

  onInput(formattedNumber: any, { number, valid, country }: any) {
    if (number.input == "00" || number.input == "+00") {
      this.creditorField.Telephone = "+";
    } else if (number.international) {
      this.creditorField.Telephone = number.international;
    }
  }

  getCreditorData() {
    if (!this.isAddCreditor()) {
      this.retrieveCreditorById(parseInt(this.$route.params.creditorId)).then(
        (response) => {
          this.creditorField = response;
          this.onUpdateInvoiceType();
        },
        (error) => {
          this.onShowFlashMessage(error, "Error", "danger");
        }
      );
    }
  }

  onSubmit() {
    this.isLoading = true;
    const insertData = {
      Name: this.creditorField.Name,
      SearchCode: this.creditorField.SearchCode,
      Country: this.creditorField.Country,
      PostalCode: this.creditorField.PostalCode,
      Address1: this.creditorField.Address1,
      City: this.creditorField.City,
      Telephone: this.creditorField.Telephone.replace(/\s/g, ""),
      ContactEmail: this.creditorField.ContactEmail,
      Category: this.creditorField.Category,
      BankInfo: {},
      CustomField: this.creditorField.CustomField,
    };
    if (this.isAddCreditor()) {
      // Case Add Creditor
      insertData.BankInfo = {
        BankTypePrimary: 203201,
        BankAccType: this.creditorField.BankInfo[0].BankAccType,
        BankAccNr: this.creditorField.BankInfo[0].BankAccNr,
        BankCurrCode: this.creditorField.BankInfo[0].BankCurrCode,
        BankName: this.creditorField.BankInfo[0].BankName,
        BankSwiftAddress: this.creditorField.BankInfo[0].BankSwiftAddress,
      };
      this.onAddCreditor(insertData);
    } else {
      // Case Edit Creditor
      if (!_.isEmpty(this.BankAddMore) && this.BankAddMore[0].BankAccType !== "") {
        // Has bank info
        insertData.BankInfo = this.BankAddMore[0];
      }
      if (Object.keys(insertData.BankInfo).length == 0) {
        delete insertData.BankInfo;
      }
      // Call Update func
      this.onUpdateCreditor(insertData);
    }
    this.ClickAddMore = false;
    this.showButtonAddMore = true;
    this.onUpdateInvoiceType();
  }

  onAddCreditor(data: any) {
    this.addCreditor(data).then(
      (response) => {
        if (response.Error) {
          this.onShowFlashMessage(response.Error.message, "Error", "danger");
        } else {
          this.creditorField = response;
          setTimeout(() => {
            this.$router.push({
              name: "CreditorDetails",
              params: { creditorId: response.Creditor },
            });
          }, 2000);
          this.onShowFlashMessage("Created Creditor Successfully!");
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  onUpdateCreditor(data: any) {
    data.Creditor = this.$route.params.creditorId;
    this.editCreditor(data).then(
      (response) => {
        if (response.Error) {
          this.onShowFlashMessage(response.Error.message, "Error", "danger");
        } else {
          this.creditorField = response;
          setTimeout(() => {
            this.$router.push({
              name: "CreditorDetails",
              params: { creditorId: this.$route.params.creditorId },
            });
          }, 2000);
          this.onShowFlashMessage("Updated Creditor Successfully!");
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  // ---- Handling BankInfo ----
  addFormBank() {
    if (this.ClickAddMore) {
      this.BankAddMore.push({
        BankAccType: "",
        BankAccNr: "",
        BankCurrCode: "",
        BankTypePrimary: 203201,
        BankName: "",
        BankSwiftAddress: "",
      });
    } else {
      this.ClickAddMore = true;
    }
    this.showButtonAddMore = false;
  }

  removeBankAddMore(index: any) {
    this.BankAddMore = this.BankAddMore.filter((con, idx) => idx !== index);
    this.showButtonAddMore = true;
  }
  // ---- End Handling BankInfo ----

  onUpdateInvoiceType() {
    // Get options of invoice types
    this.invoiceTypeOptions = [];
    for (const opt of this.creditorField.CustomField.InvoiceType) {
      this.invoiceTypeOptions.push({ text: opt, value: opt });
    }
  }
}
